import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {EventExtended, EventSmall} from '@/features/agenda/types.ts'
import {raise} from '@utilities/helpers.ts'
import {ResponseType} from '@/types'
import {httpGetEvent} from '@/features/agenda/http/agenda.http'

type EventResponse<T extends ResponseType> = T extends 'extended' ? EventExtended : EventSmall

export const useGetEvent = <T extends ResponseType>({
    eventId,
    responseType,
    options
}: {
    eventId?: string
    responseType?: T
    options?: Omit<UseQueryOptions<EventResponse<T>>, 'queryKey' | 'queryFn'>
}) =>
    useQuery({
        queryKey: [QUERY_KEYS.AGENDA_EVENTS, responseType, eventId],
        queryFn: () =>
            httpGetEvent({
                urlParams: {eventId: eventId ?? raise('eventId is nullish')},
                params: {responseType: responseType ?? 'extended'}
            }),
        ...options
    })
